module.exports = __webpack_public_path__ + "static/media/icon_PDF_W.b823e151.svg";